import React, { useState, useEffect, Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  DatePicker,
  Tabs,
  Button,
  Table,
  Drawer,
  Popconfirm,
  Input,
} from 'antd';
import H3Text from '@Uilib/h3Text';
import H3FormInput from '@Uilib/h3FormInput';
import TenantSelector from '../../../../Common/Selector/TenantSelector';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import StockMasterActions from '@Actions/inventory/stockMasterActions';
import { v4 as uuidv4 } from 'uuid';
import Helpers from '@Apis/helpers';
import FilterProducts from '../FilterProducts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCubes, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import './style.scss';

const { Search } = Input;

const PriceListForm = ({
  user, createProductList, createProductListLoading, updateProductList, updateProductListLoading, getProductListByIdLoading,
  callback, getProductListById, selectedProductList, productListId, removeProductFromList, removeProductFromListLoading,
  getProductListByIdSuccess, addProductToList, addProductToListLoading,
}) => {
  const [selectedTenant, setSelectedTenant] = useState([]);
  const [productListName, setProductListName] = useState('');
  const [description, setDescription] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [activeTab, setActiveTab] = useState('1');
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [tableDataForProduct, setTableDataForProduct] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState(null);
  const [selectedRows, setSelectedRows] = useState(null);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [call, setCall] = useState(false);

  const handleDelete = (key, isMultiple) => {
    let newTableData;
    if(isMultiple) {
      newTableData = tableDataForProduct?.filter((item) => !selectedRowKeys?.includes(item.key));
    }
     else {
      newTableData = tableDataForProduct?.filter((item) => item.key !== key);
     }
     if(productListId && selectedProductList) {
      let payload;
      if(isMultiple) {
        payload = key?.map((i) => ({
          sku_list_id: productListId,
          product_sku_id: i,
        }));
      } else {
        payload = [{
          sku_list_id: productListId,
          product_sku_id: key,
        }]
      }
      removeProductFromList(payload, () => {
        setCall(!call);
        setSelectedRowKeys(null);
        setSelectedRows(null);
      })
     } else {
      setTableDataForProduct(newTableData);
     }
     setSearchKeyword('');
  };
  const columnsForSelectProducts = [
    {
      title: 'SKU#',
      key: 'product_info',
      width: '100px',
      render: (text, record) => (
        <Link to={`/inventory/product/view/${record?.product_sku_info?.product_sku_id}?tab=/general-information`}>
          {`#${record?.product_sku_info?.internal_sku_code}`}
        </Link>
      )
    },
    {
      title: 'Product',
      key: 'product_info',
      render: (text, record) => (
        <div
          style={{
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            width: '500px',
            overflow: 'hidden',
          }}
        >
          {`${record?.product_sku_info?.ref_product_code ? `${record?.product_sku_info?.ref_product_code} - ` : ''}${record?.product_sku_info?.product_sku_name}`}
        </div>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: '',
      fixed: 'right',
      width: 40,
      render: (text, record) => (
        <Popconfirm
          title="Are you sure you want to remove this item?"
          onConfirm={() => handleDelete(record?.key, false)}
        >
          <div className="delete-line-button__new" style={{ marginLeft: 'auto' }}>
            <FontAwesomeIcon icon={faTrashCan} />
          </div>
        </Popconfirm>
      ),
    },
  ];

  useEffect(() => {
    if (productListId) {
      getProductListById({
        tenantId: selectedTenant,
        skuListId: productListId,
      }, (productListData) => {
        setProductListName(productListData?.list_name);
        setSelectedTenant(productListData?.tenant_id);
        setDescription(productListData?.list_description);
        setTableDataForProduct(productListData?.sku_list_products?.map((item) => ({
          ...item,
          key: item?.product_sku_id,
        })));
      });
    }
  }, [call]);

  useEffect(() => {
    return () => {
      getProductListByIdSuccess(null);
    } 
  }, [])

  const handleAddProductList = () => {
    setFormSubmitted(true);
  
    if (productListName) {
      const payload = {
        list_name: productListName,
        list_description: description,
        tenant_ids: selectedTenant?.join(','),
      };

      if (productListId) {
        payload.sku_list_id = productListId;
        updateProductList(payload, () => {
          callback();
        });
      } else {
        payload.sku_list_products = tableDataForProduct?.map((i) => i?.product_sku_id)?.join(','),
        createProductList(payload, () => {
          callback();
        });
      }
    }
  };

  const isInputDisabled = createProductListLoading || updateProductListLoading || getProductListByIdLoading;

  return (getProductListByIdLoading && !selectedProductList)
    ? (
      <React.Fragment>
        <div className="view-price-list__loading">
          <div className="loadingBlock view-price-list__loading-l1" />
          <div className="loadingBlock view-price-list__loading-l2" />
          <div className="loadingBlock view-price-list__loading-l3" />
          <div className="loadingBlock view-price-list__loading-l4" />
          <div className="loadingBlock view-price-list__loading-l5" />
        </div>
      </React.Fragment>
    )
    : (
      <div className="create-product-group__wrapper">
        <Drawer
          placement="right"
          onClose={() => setDrawerVisible(false)}
          visible={drawerVisible}
          width={720}
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header">
              <H3Text text="Add products" className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setDrawerVisible(false)} />
            </div>
            <FilterProducts
              tenantId={user?.tenant_info?.tenant_id}
              onSubmit={(data) => {
                if(!selectedProductList && !productListId) {
                  setTableDataForProduct([
                    ...tableDataForProduct,
                    ...data,
                  ])
                } else {
                  addProductToList(data?.map((i) => ({
                    sku_list_id : productListId,
                    product_sku_id : i?.key,
                  })), () => {
                    setCall(!call);
                    setSearchKeyword('');
                  })
                }
              }}
              selectedProducts={tableDataForProduct}
              callback={() => setDrawerVisible(false)}
            />
          </div>
        </Drawer>
        <div className="ant-row">
            <div className="ant-col-md-12">
                <H3FormInput
                  name="Product Group Name"
                  type="text"
                  label="Product Group Name"
                  containerClassName="orgInputContainer"
                  labelClassName="orgFormLabel"
                  inputClassName="orgFormInput input"
                  placeholder="eg. Unicommerce sync list"
                  disabled={isInputDisabled}
                  onChange={(e) => setProductListName(e.target.value)}
                  value={productListName}
                  required
                  showError={formSubmitted && !productListName}
                />
            </div>
            <div className="ant-col-md-12">
                <H3FormInput
                  name="Group Description"
                  type="text"
                  label="Description"
                  containerClassName="create-price-list__input-row__input"
                  labelClassName="orgFormLabel"
                  inputClassName="orgFormInput input"
                  placeholder="eg. Unicommerce sync list"
                  disabled={isInputDisabled}
                  onChange={(e) => setDescription(e.target.value)}
                  value={description}
                  required
                  showError={formSubmitted && !description}
                />
            </div>
            <div className="ant-col-md-24">
                <TenantSelector
                  selectedTenant={selectedTenant}
                  noDropdownAlign
                  showSearch
                  onChange={(value) => {
                    setSelectedTenant(value);
                  }}
                  label="Locations"
                  style={{
                    border: '1px solid rgba(68, 130, 218, 0.2)',
                    borderRadius: '2px',
                    height: '32px',
                    width: '100%',
                    fontSize: '13px',
                  }}
                  containerClassName="create-price-list__input-row__input"
                  placeholder="Select Business Unit"
                  isMultiple
                  includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PRODUCT, Helpers.permissionTypes.READ)}
                  showError={formSubmitted && selectedTenant?.length < 1}
                  disabled={isInputDisabled}
                />

            </div>
            <div className="ant-col-md-24">
              <div className="create-product-group__title-wrapper">
                <div className="create-product-group__title">
                  <FontAwesomeIcon icon={faCubes} />
                  <H3Text text={`${tableDataForProduct?.length ? tableDataForProduct?.length : '0'} Products in this Group`} className="" />
                </div>
                <Table
                  columns={columnsForSelectProducts}
                  scroll={{ y: 'calc(100dvh - 420px)' }}
                  pagination={false}
                  bordered={false}
                  size="small"
                  dataSource={tableDataForProduct?.filter((item) => 
                    item?.product_sku_info?.ref_product_code?.toLowerCase()?.includes(searchKeyword?.toLowerCase()) || item?.product_sku_info?.product_sku_name?.toLowerCase()?.includes(searchKeyword?.toLowerCase())
                  )}
                  title={() => (
                    <div className="flex-display">
                      <Search
                        placeholder="search by name.."
                        onChange={(event) => {
                            setSearchKeyword(event.target.value);   
                        }}
                        style={{ width: 200 }}
                      />
                      <div className="margin-left-auto flex-display">
                          <Button
                            type="primary"
                            danger 
                            onClick={() => handleDelete(selectedRowKeys, true)}
                            disabled={!selectedRows?.length || removeProductFromListLoading}
                            loading={removeProductFromListLoading || getProductListByIdLoading}
                          >
                            Remove
                          </Button>
                          &nbsp;
                          <Button
                            type="primary" 
                            onClick={() => setDrawerVisible(true)}
                            disabled={!selectedTenant?.length || addProductToListLoading}
                            loading={addProductToListLoading || getProductListByIdLoading}
                          >
                            + Add Products
                          </Button>
                      </div>
                    </div>
                  )}
                  rowSelection={{
                    onChange: (rowKeys, rows) => {
                      setSelectedRowKeys(rowKeys);
                      setSelectedRows(rows);
                    },
                    selectedRowKeys,
                  }}
                  loading={removeProductFromListLoading || addProductToListLoading}
                />
              </div>
            </div>

          </div>

        <div className="custom-drawer__footer" style={{ width: '1030px' }}>
          <div className="ant-col-md-6" style={{ marginTop: '0.5rem' }}>
            <Button type="primary"
              onClick={() => handleAddProductList()}
              loading={createProductListLoading || updateProductListLoading}
              disabled={isInputDisabled}
            >
              {productListId ? 'Update Product Group' : 'Create Product Group'}
            </Button>
          </div>
        </div>
      </div >
    );
};

const mapStateToProps = ({
  TenantReducers, StockMasterReducers, UserReducers,
}) => ({
  user: UserReducers.user,
  updateProductListLoading: StockMasterReducers.updateProductListLoading,
  createProductListLoading: StockMasterReducers.createProductListLoading,
  getProductListByIdLoading: StockMasterReducers.getProductListByIdLoading,
  selectedProductList: StockMasterReducers.selectedProductList,
  addProductToListLoading: StockMasterReducers.addProductToListLoading,
  removeProductFromListLoading: StockMasterReducers.removeProductFromListLoading,
});

const mapDispatchToProps = (dispatch) => ({
  createProductList: (paylaod, callback) => dispatch(StockMasterActions.createProductList(paylaod, callback)),
  updateProductList: (paylaod, callback) => dispatch(StockMasterActions.updateProductList(paylaod, callback)),
  getProductListById: (payload, callback) => dispatch(StockMasterActions.getProductListById(payload, callback)),
  removeProductFromList: (payload, callback) => dispatch(StockMasterActions.removeProductFromList(payload, callback)),
  addProductToList: (payload, callback) => dispatch(StockMasterActions.addProductToList(payload, callback)),
  getProductListByIdSuccess: (selectedProductList) => dispatch(StockMasterActions.getProductListByIdSuccess(selectedProductList)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PriceListForm));
